var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18945 5.83008L0.205078 1.8457C0.0683594 1.70898 0 1.54297 0 1.34766C0 1.15234 0.0683594 0.986328 0.205078 0.849609L0.878906 0.205078C1.01562 0.0683594 1.18164 0 1.37695 0C1.57227 0 1.73828 0.0683594 1.875 0.205078L4.6875 3.01758L7.5 0.205078C7.63672 0.0683594 7.80273 0 7.99805 0C8.19336 0 8.35938 0.0683594 8.49609 0.205078L9.16992 0.849609C9.30664 0.986328 9.375 1.15234 9.375 1.34766C9.375 1.54297 9.30664 1.70898 9.16992 1.8457L5.18555 5.83008C5.04883 5.9668 4.88281 6.03516 4.6875 6.03516C4.49219 6.03516 4.32617 5.9668 4.18945 5.83008Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowDown.97b28fd7.svg";
export { ForwardRef as ReactComponent };